/**
 * Marquage UTM des liens de partage (décision S-D6, 2026-10-26).
 *
 * Pendant de api/app/utm.py côté interface. Les valeurs de `utm_medium` suivent le
 * regroupement de canaux par défaut de Google Analytics 4 : « social » → Social organique,
 * « referral » → Référent.
 *
 * Différence voulue avec le serveur : ici les paramètres utm_* déjà présents dans l'URL
 * sont REMPLACÉS. L'URL partagée est celle de la page courante, qui porte encore les
 * paramètres d'arrivée de la personne qui partage (ex. utm_source=email) : les propager
 * attribuerait au canal d'origine une visite venue du partage.
 */

export interface ParametresUtm {
  source: string;
  medium: string;
  campaign: string;
}

export function ajouterUtm(url: string, utm: ParametresUtm): string {
  let u: URL;
  try {
    u = new URL(url);
  } catch {
    return url;
  }
  Array.from(u.searchParams.keys())
    .filter((cle) => cle.toLowerCase().startsWith('utm_'))
    .forEach((cle) => u.searchParams.delete(cle));
  u.searchParams.set('utm_source', utm.source);
  u.searchParams.set('utm_medium', utm.medium);
  u.searchParams.set('utm_campaign', utm.campaign);
  return u.toString();
}
